import { render, staticRenderFns } from "./NotificationDrawer.vue?vue&type=template&id=68937a12&scoped=true"
import script from "./NotificationDrawer.vue?vue&type=script&lang=js"
export * from "./NotificationDrawer.vue?vue&type=script&lang=js"
import style0 from "./NotificationDrawer.vue?vue&type=style&index=0&id=68937a12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68937a12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68937a12')) {
      api.createRecord('68937a12', component.options)
    } else {
      api.reload('68937a12', component.options)
    }
    module.hot.accept("./NotificationDrawer.vue?vue&type=template&id=68937a12&scoped=true", function () {
      api.rerender('68937a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/common-drawer/NotificationDrawer.vue"
export default component.exports